import { render, staticRenderFns } from "./TrafiklabViewer.vue?vue&type=template&id=43d5f531&scoped=true&"
import script from "./TrafiklabViewer.vue?vue&type=script&lang=js&"
export * from "./TrafiklabViewer.vue?vue&type=script&lang=js&"
import style0 from "./TrafiklabViewer.vue?vue&type=style&index=0&id=43d5f531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d5f531",
  null
  
)

export default component.exports